import { AccordionTrigger, type AccordionTriggerProps } from '@seen/ui'

export type DisclosureTriggerProps = AccordionTriggerProps

export const DisclosureTrigger = AccordionTrigger
